import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classes from "./CategoryPage.module.css";
import styles from './OtpVerify.module.css';
import Lottie from 'lottie-react';
import { FaArrowLeft } from "react-icons/fa";
import stars from "../animations/stars3.json";
import { OtpVerifyApi } from '../http/http';
import { useLocation, useSearchParams } from "react-router";
import { toast } from "react-toastify";
import LanguageSelector from './LanguageSelector';
import { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import TopHeroWithForm from './TopHeroWithImage';
import Terms from '../components/Terms';


const OtpVerify = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(120);

  const [searchParams] = useSearchParams();
  const { lang } = useContext(LanguageContext);

  const location = useLocation();
  const [msisdn, setMsisdn] = useState('')

  console.log("msisdn", msisdn);

  useEffect(() => {

    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer); 
    } else {

      navigate('/');
    }

  }, [timeLeft, navigate]);

  useEffect(() => {
    console.log(location?.state?.msisdn)
    if (location?.state?.msisdn) {
      setMsisdn(location?.state?.msisdn);

    }
    else {
      navigate('/')
    }
  }, [location])

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? '0' : ''}${sec}`;
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    const ext_id = searchParams.get("ext_id")
    
    if (otp.trim().length !== 6) {
      toast.error('Enter a valid 6-digit OTP');
      return;
    }

    try {
      setLoading(true);
      const response = await OtpVerifyApi(otp, msisdn, ext_id);
      console.log("response from backend", response)

      console.log("resmsg", response?.data?.msg)
      console.log("success", response?.data?.success)
      console.log("msisdn", msisdn);
      if (response?.data?.success) {
        toast.success(response?.data?.msg);
        navigate(`/home?ext_id=${ext_id}`,{
          state:{
            msisdn: msisdn
          }
        });
      } else {
        toast.error(response?.data?.msg)
      }

    } catch (error) {
      toast.error("Something went wrong while sending OTP!");

    }

  };

  return (
    <>
    <div className={styles.container}>

      <LanguageSelector />
  
        <div className={styles.topImageWrapper}>
      <img
        src={
          lang === "eng"
            ? "/assets/images/otpeng.png"
            : "/assets/images/otparabic.png"
        }
        alt="kids"
        className={styles.topImage}
      />
    </div>
       
      <Lottie
        animationData={stars}
        loop={true}
        autoplay={true}
        initialSegment={[0, 100]}
        className={classes.background_animation}
      />
      <div className={styles.arrow_container}>
        <FaArrowLeft className={styles.arrow_left} onClick={() => navigate('/')} />
      </div>
      <div className={styles.card}>
        <h2 className={styles.title}>{lang=="eng" ? "Fill Your Zip Code" :"ادخل الرمز"}</h2>
        {/* <p className={styles.desc}>{lang=="eng" ? "We sent an OTP to" :"لقد أرسلنا OTP إلى"} <strong>{msisdn}</strong></p> */}

        <form onSubmit={handleVerify} className={styles.form}>
          <input
            className={styles.input}
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="XXXXXX"
            inputMode="numeric"
          />
          <button className={styles.button} type="submit" disabled={loading}>
           {loading ? (lang === "ar" ? "جاري..." : "Loading...") : (lang === "ar" ? "اشترك" : "Subscribe")}
          </button>
        </form>


        <p className={styles.timer}>
        {lang=="eng" ? "Time left" :"الوقت المتبقي"} : <strong>{formatTime(timeLeft)}</strong>
        </p>

      </div>

    </div>
    <Terms />
    </>
  );
}

export default OtpVerify;